<template>
    <!-- 给管理员发送信息 -->
    <div style="padding:30px">
        <div class="my-title">
            <span>发送信息</span>
        </div>
        <el-form ref="form" hide-required-asterisk=true :rules="rules" :model="sendObj" label-width="80px">
            <el-form-item label="收件人" prop="mobile">
                <div class="send_tetx">
                    <el-input class="adm" v-model="sendObj.mobile"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="标题" prop="title">
                <div class="send_tetx">
                    <el-input class="adm" v-model="sendObj.title"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="内容" prop="content">
                <div class="send_tetx">
                    <el-input  type="textarea" resize="none" rows="4" maxlength="100" class="adm" v-model="sendObj.content"></el-input>
                </div>
            </el-form-item>
            <el-form-item>
                <div class="send_tetx">
                    <el-button type="primary" @click="send">发送</el-button>
                    <el-button type="info" @click="resetSend">取消</el-button>
                    <el-button type="info" @click="sendSave">取消并保存草稿箱</el-button>
                </div>
            </el-form-item>
        </el-form>

    </div>
</template>
<script>
if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
import { userLetterSave } from "@/api/index.js";
export default {
    data() {
        return {
            sendObj: {
                id: "",
                type: 1,
                mobile: "",
                title: "",
                content: "",
                "switch": ""
            },
            rules:{
            mobile:[
            { required: true, message: '请输入收件人手机号', trigger: 'blur' },
            { pattern: /^1[3|5|7|8|9]\d{9}$/, message: '请输入正确的号码格式', trigger: 'change'}
            ],
            title:[
            { required: true, message: '请输入标题', trigger: 'blur' },
            ],
            content:[
            { required: true, message: '请输入内容', trigger: 'blur' },
            ]

            }
        };
    },
    created() {},
    methods: {
        //发送
        send() {
            this.$refs.form.validate(valid=>{
            this.sendObj.switch = 1;
            console.log();
            userLetterSave(this.sendObj,header).then(res=>{
            console.log(res);
            if(res.code !== 1){
                return
            }
            this.$message.success(res.msg)
            this.$refs.form.resetFields()
            })
            })

        },
        //取消保存草稿箱
        sendSave() {
          this.$refs.form.validate(valid=>{
            this.sendObj.switch = 0;
             userLetterSave(this.sendObj,header).then(res=>{
            console.log(res);
            if(res.code !== 1){
                return
            }
            this.$message.success(res.msg)
            this.$refs.form.resetFields()
            })

            })

        },
        //取消
        resetSend(){
        this.$refs.form.resetFields()
        }
    }
};
</script>
<style lang="less" scoped>
.my-title {
    font-size: 20px;
    padding: 0 10px;
    border-left: 5px solid #ff6701;
    margin-bottom: 10px;
    margin-left: -10px;
    span {
        width: 80px;
        height: 20px;
        font-size: 20px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #323232;
        line-height: 30px;
    }
}
.send_tetx {
    display: flex;
    span {
        height: 31px;
        line-height: 31px;
        padding-right: 12px;
        padding-bottom: 24px;
    }
    .adm {
        width: 236px;
        height: 31px;
    }
    .send_title {
        padding-left: 14px;
    }
    .el-textarea {
        width: 335px;
        height: 92px;
    }
}
.send_bnt {
    padding-left: 58px;
}
.el-button--info {
    color: #fff;
    background-color: #d7d7d7;
    border-color: #d7d7d7;
}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/components/sendInformation.vue